

import React from 'react';
import { FormattedCurrency } from '../../../Common/FormattedCurrency';

export const FinancialSchedules: React.FC = () => {
  return (
    <section className="glass-panel p-5 md:p-6 flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <h3 className="text-sm md:text-base font-bold text-text-primary">Financial Schedules</h3>
        <span className="bg-primary-accent-bg text-primary-accent px-2 py-0.5 rounded-lg text-[10px] font-extrabold">3 Pending</span>
      </div>

      <div className="flex flex-col gap-3">
        <div className="flex gap-3.5 p-3 rounded-2xl bg-bg-deep border border-border-color">
          <div className="flex flex-col items-center justify-center w-11 h-11 rounded-xl bg-blue-500/10 text-primary-accent shrink-0">
            <span className="text-[9px] font-extrabold">JUN</span>
            <span className="text-sm font-extrabold leading-none mt-0.5">22</span>
          </div>
          <div className="flex flex-col gap-0.5 justify-center">
            <span className="text-xs md:text-sm font-bold text-text-primary">Credit Card Auto-Pay</span>
            <span className="text-[10px] md:text-xs text-text-muted"><FormattedCurrency value={1240.00} /> • Scheduled</span>
          </div>
        </div>

        <div className="flex gap-3.5 p-3 rounded-2xl bg-bg-deep border border-border-color">
          <div className="flex flex-col items-center justify-center w-11 h-11 rounded-xl bg-emerald-500/10 text-emerald-500 shrink-0">
            <span className="text-[9px] font-extrabold">JUN</span>
            <span className="text-sm font-extrabold leading-none mt-0.5">24</span>
          </div>
          <div className="flex flex-col gap-0.5 justify-center">
            <span className="text-xs md:text-sm font-bold text-text-primary">Vanguard Dividend</span>
            <span className="text-[10px] md:text-xs text-text-muted">+<FormattedCurrency value={450.00} /> • Pending Deposit</span>
          </div>
        </div>

        <div className="flex gap-3.5 p-3 rounded-2xl bg-bg-deep border border-border-color">
          <div className="flex flex-col items-center justify-center w-11 h-11 rounded-xl bg-purple-500/10 text-accent-violet shrink-0">
            <span className="text-[9px] font-extrabold">JUN</span>
            <span className="text-sm font-extrabold leading-none mt-0.5">28</span>
          </div>
          <div className="flex flex-col gap-0.5 justify-center">
            <span className="text-xs md:text-sm font-bold text-text-primary">Expense Audit Review</span>
            <span className="text-[10px] md:text-xs text-text-muted">Q2 Reconciliation • Required</span>
          </div>
        </div>
      </div>
    </section>
  );
};
